"use strict";
/*
 * Created on 02 08 2021
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author Jaroslav Sevcik
 */


var OptimizationScenarioDataConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(OptimizationScenarioDataConverter, _DataObjectConverter_);

  function OptimizationScenarioDataConverter() {
    _classCallCheck(this, OptimizationScenarioDataConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(OptimizationScenarioDataConverter).apply(this, arguments));
  }

  return OptimizationScenarioDataConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.OptimizationScenarioDataConverter = OptimizationScenarioDataConverter;